import React, { useState } from 'react'
import CloseIcon from "../../../Images//cancelicon.svg"
import { useNavigate } from 'react-router-dom';
import useLogin from '../hooks/useLogin';
import PasswordOpen from '../../../Images/passwordeyeopen.png'
import PasswordClose from '../../../Images/passwordeyeclose.png'

function FamilyLoginPopup({ onClose, dropdownData }) {
  const [formData, setFormData] = useState({
    mobileNumber: "",
    isdCode: 499,
  });

  const [familyFormData, setFamilyFormData] = useState({
    member: "",
    password: "",
  })
  

  const [showLogin, setShowLogin] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [familyNumberList, setfamilyNumberList] = useState([])

  const navigate = useNavigate()
  const { getFamilyNumbers, isFamilyNumbersLoading,validateFamilyForm,familyMemberFormError,isFamilyLoginLoading, familyLogin } = useLogin()

  const [errors, setErrors] = useState(null);
  const validateForm = () => {
    const errors = {};

    if (!formData.mobileNumber) {
      errors.mobileNumber = "Please Enter Mobile Number";
    } else if (errors.isdCode == 499) {
      if (formData.mobileNumber.length !== 10) {
        errors.mobileNumber = "Please enter a valid Mobile Number";
      }
    } else {
      if (formData.mobileNumber.length < 7 || formData.mobileNumber.length >= 15) {
        errors.mobileNumber = "Please enter a valid Mobile Number";
      }
    }


    if (Object.keys(errors).length > 0) {
      setErrors(errors)
      return false;
    } else {
      setErrors(null)
    }
    return true;
  };




  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleFamilyInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFamilyFormData(prev=>({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const onNumberSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      const response = await getFamilyNumbers(formData.mobileNumber)
      if (response.error) {
        setErrors({ mobileNumber: response.errorMessage })
      } else {
        setShowLogin(true)
        setErrors(null)
        setfamilyNumberList(response?.data)
      }
    }
  }

  const familyLoginSubmit =async (e)=>{
    e.preventDefault();
    if(validateFamilyForm(familyFormData)){
      familyLogin(formData.mobileNumber,familyFormData.member,familyFormData.password)
    }
  }





  return (
    <div className="popup-modal">
      <div className="popup-modal-content">
        <button type="button" className='popup-close-icon' onClick={onClose}>
          <img className="familyclose-btn-width cursor-pointer" src={CloseIcon} alt="" />
        </button>
        {
          showLogin
            ? <>
              <div style={{flexDirection:"column"}} className='popup-model-header'>
                <p>FAMILY/FRIEND LOGIN</p>
                <p className="family-popup-membertext ">Choose Member and Enter Password</p>
              </div>
              <form onSubmit={familyLoginSubmit} style={{ maxWidth: "70%", margin: "auto" }} id="family-form">
                <div className=" labeldiv labelcolumn">
                  <label style={{width:"100%"}} className="family-from-labelselect ">
                    <select
                    style={{width:"100%"}}
                      name="member"
                      id="member"
                      value={familyFormData?.member}
                      onChange={handleFamilyInputChange}
                      disabled={isFamilyLoginLoading}
                      placeholder="Select Member"
                      className="family-form-select"
                    >
                      <option>Select Member</option>
                    {familyNumberList?.map((member) => (
                      member?.familynumber === "Y" && (
                        <option key={member.id} value={member.id}>
                          {member.name} / {member.id}
                        </option>
                      )
                    ))}
                    </select>
                  </label>
                  {familyMemberFormError?.member && <div className="errormsgs">{familyMemberFormError?.member}</div>}
                  </div>
                <div className='labeldiv labelcolumn'>
                  <label style={{width:"100%"}} className=" family-password ">
                    <input
                    style={{width:"100%"}}
                      id="memberPassoword"
                      name="password"
                      value={familyFormData?.password}
                      onChange={handleFamilyInputChange}
                      disabled={isFamilyLoginLoading}
                      autoComplete="off"
                      placeholder="Enter Password"
                      type={showPassword ? "text" : "password"}
                      className="family-pswinput"
                    />
                    <div onClick={() => setShowPassword(prev => !prev)} className="hideicon">
                      {showPassword
                        ? <img
                          src={PasswordClose}
                          className=""
                          alt=""
                        />
                        : <img
                          src={PasswordOpen}
                          className=""
                          alt=""
                        />}
                    </div>
                  </label>
                  {familyMemberFormError?.password && <div className="errormsgs">{familyMemberFormError?.password}</div>}
                </div>
                <div style={{ justifyContent: "center" }} className="popup-footer">
                  {/* <div className="familybtncolumn cancelbtn-primary" onClick={onClose}>Cancel</div> */}
                  <button disabled={isFamilyLoginLoading} type="submit" className="familybtnspan submitbtn-primary">{isFamilyLoginLoading ? "Logging in..." : "Login"}</button>
                </div>
              </form>
            </>
            : <>
              <div className='popup-model-header'>
                <p>FAMILY/FRIEND LOGIN</p>
              </div>
              <form style={{  margin: "auto" }} id="loginFamilyfriend" onSubmit={onNumberSubmit}>
                <div className="labelgrid">
                  <div className="labeldiv labelcolumn">
                    <div>
                      <label className="formlabel">
                        <select
                          id="isdCode"
                          name="isdCode"
                          value={formData.isdCode}
                          onChange={handleInputChange}
                          disabled={isFamilyNumbersLoading}
                          className="one form-input forminput">
                          <option value="" disabled="">Select</option>
                          {dropdownData?.isdcode?.map((isdcode, i) => (
                            <option key={isdcode.countryId} className="p-2" value={isdcode.countryId}>
                              {isdcode.isdcode + "," + isdcode.country}
                            </option>
                          ))}

                        </select>
                      </label>
                    </div>
                  </div>
                  <div className="labeldiv labelspan">
                    <div>
                      <label style={{ display: "flex" }} className="formlabel RegPhone">
                        <input
                          id="phone"
                          name="mobileNumber"
                          type="tel"
                          disabled={isFamilyNumbersLoading}
                          value={formData.mobileNumber}
                          onChange={handleInputChange}
                          autoComplete="off"
                          style={{ flex: 1 }}
                          placeholder="Enter Your Phone Number"
                          className="RegPhone form-input phonenoinput phone"
                        />
                      </label>
                    </div>
                    {errors?.mobileNumber && <div className="errormsgs">{errors?.mobileNumber}</div>}
                  </div>

                </div>
                <div style={{ justifyContent: "center" }} className="popup-footer">
                  {/* <div className="familybtncolumn cancelbtn-primary" onClick={onClose}>Cancel</div> */}
                  <button disabled={isFamilyNumbersLoading} type="submit" className="familybtnspan submitbtn-primary">{isFamilyNumbersLoading ? "Submitting..." : "Submit"}</button>
                </div>

              </form>
            </>
        }

      </div>
    </div>
  )
}

export default FamilyLoginPopup